import * as React from "react";
import { PortCors } from "./port_cors";
import { PortTls } from "./port_tls";
import { PortRoutes } from "./port_routes";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { Card } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../../gvc/testNewForm/CpSelect";
import { CpErrorWarningArray } from "../../../gvc/testNewForm/CpErrorWarningArray";

interface Props {
  index: number;
}
export const Port: React.FC<Props> = React.memo(({ index }) => {
  const number = useCpFormValue(`advanced.spec.ports.${index}.number`);

  return (
    <div className="cpln-form-section cpln-ant-tab-content" data-section-id={`local-options-${index}`}>
      <Card>
        <CardTitle>Port {number}</CardTitle>
        <CardContent>
          <CpFormItem>
            <div className="flex gap-2" style={{ maxWidth: 600 }}>
              <div className="flex flex-col">
                <CpLabel name={`advanced.spec.ports.${index}.number`}>Number</CpLabel>
                <CpInput name={`advanced.spec.ports.${index}.number`} placeholder="443" />
              </div>
              <div className="flex flex-col">
                <CpLabel name={`advanced.spec.ports.${index}.protocol`}>Protocol</CpLabel>
                <CpSelect
                  name={`advanced.spec.ports.${index}.protocol`}
                  options={[
                    { label: "http", value: "http" },
                    { label: "http2", value: "http2" },
                    { label: "tcp", value: "tcp" },
                  ]}
                />
              </div>
            </div>
            <CpErrorWarningArray
              names={[`advanced.spec.ports.${index}.number`, `advanced.spec.ports.${index}.protocol`]}
            />
          </CpFormItem>
          <PortRoutes index={index} />
          <PortTls index={index} />
          <PortCors index={index} />
        </CardContent>
      </Card>
    </div>
  );
});
